import React from 'react';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import {
  Alert as ShadcnAlert,
  AlertDescription,
  AlertTitle,
} from '@/components/ui/alert';

const VARIANTS = {
  DEFAULT: 'default',
  DESTRUCTIVE: 'destructive',
  SUCCESS: 'success',
};

const Alert = ({ title, description = '', icon = null, variant = VARIANTS.DEFAULT }) => (
  <ShadcnAlert variant={variant}>
    {icon}

    <AlertTitle>{title}</AlertTitle>

    {!isEmpty(description) && (
      <AlertDescription>
        <p>{description}</p>
      </AlertDescription>
    )}
  </ShadcnAlert>
);

Alert.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  icon: PropTypes.element,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
};

export default Alert;
